export default "__VITE_ASSET__D$FuHlTu__"